// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_GX9","cls2":"Search-cls2_gC8 Search-cls1_GX9"};